var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.006 22q-.826 0-1.414-.587A1.93 1.93 0 0 1 6.004 20q0-.824.588-1.413A1.93 1.93 0 0 1 8.006 18q.825 0 1.413.587.588.588.588 1.413 0 .824-.588 1.413A1.93 1.93 0 0 1 8.006 22m10.009 0q-.825 0-1.414-.587A1.93 1.93 0 0 1 16.013 20q0-.824.588-1.413A1.93 1.93 0 0 1 18.015 18q.825 0 1.414.587.588.588.588 1.413 0 .824-.588 1.413a1.93 1.93 0 0 1-1.414.587M7.155 6l2.402 5h7.007l2.752-5zm-.951-2h14.764q.575 0 .875.513.3.512.025 1.037l-3.553 6.4q-.275.5-.738.775a1.95 1.95 0 0 1-1.014.275H9.108l-1.101 2h11.01q.425 0 .713.287.288.288.288.713 0 .424-.288.712a.97.97 0 0 1-.713.288H8.006q-1.126 0-1.702-.988-.576-.987-.05-1.962l1.351-2.45L4.002 4H3a.97.97 0 0 1-.713-.288A.97.97 0 0 1 2 3q0-.424.288-.712A.97.97 0 0 1 3 2h1.626q.277 0 .526.15.25.15.375.425z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.871c020194d3c6711dd39af708e01ea0.svg";
export { ForwardRef as ReactComponent };